import { apiClient } from './apiClient';
import config from '../config/environment';
const BASE_URL = config.BASE_URL;
const apiBaseUrl = process.env.REACT_APP_HOST_URL || `${BASE_URL}`;

const getAuthHeaders = (): HeadersInit => {
  const headers: HeadersInit = {};
  const userLoginData = localStorage.getItem('userLoginData');
  if (userLoginData) {
    const parsedUserData = JSON.parse(userLoginData);
    if (parsedUserData?.api_key && parsedUserData?.api_secret) {
      // headers["Authorization"] = `Bearer token ${parsedUserData.api_key}:${parsedUserData.api_secret}`;
      headers['Authorization'] = `token ${parsedUserData.api_key}:${parsedUserData.api_secret}`;
      // console.log("Headers:", headers);
    }
  }
  return headers;
};

const UpdateProfile = async (formData: FormData) => {
  const headers = getAuthHeaders();
  const response = await fetch(`${apiBaseUrl}/retailer_app.api.retailer.update_customer_detail`, {
    method: 'PUT',
    headers: headers,
    // credentials: "include",
    body: formData,
  });
  const data = await response.json();
  return data;
};

const Profile = (id: string) => apiClient(`/retailer_app.api.retailer.get_customer_detail?customer_id=${id}`, 'GET');
const UpdateProfileApiClient = (data: FormData) =>
  apiClient('/retailer_app.api.retailer.update_customer_detail', 'PUT', data);
const SignUp = (data: any) => apiClient('/retailer_app.api.login.customer_signup', 'POST', data);
const CheckMobileNumber = (mobile: number) =>
  apiClient(`/retailer_app.api.login.check_customer_mobile?phone_no=${mobile}`, 'GET');
const AddressList = (id: string) => apiClient(`/retailer_app.api.retailer.address_list?customer_id=${id}`, 'GET');
const GetSingleAddress = (id: string, addressId?: string) =>
  apiClient(`/retailer_app.api.retailer.address_list?customer_id=${id}&address_id=${addressId}`, 'GET');
const UpdateAddress = (payload: any) => apiClient('/retailer_app.api.retailer.update_address', 'PUT', payload);
const CreateAddress = (payload: any) => apiClient('/retailer_app.api.retailer.create_new_address', 'POST', payload);

export const UserService = {
  Profile,
  UpdateProfile,
  UpdateProfileApiClient,
  SignUp,
  CheckMobileNumber,
  AddressList,
  UpdateAddress,
  CreateAddress,
  GetSingleAddress,
};
